import thematicMeetingService from '@/api/thematic-meetings/thematicMeetingService';
import { useTranscriptRecap } from '@/components/MeetingTranscript/useTranscriptRecap';
import { thematicMeetingTranscriptKey } from '@/constants/QueryKeys';

/** The AI recap of the transcript uploaded for a thematic meeting. */
export const useThematicMeetingRecap = (
    meetingId: string | undefined,
    pendingCorrelationId?: string | null,
) =>
    useTranscriptRecap({
        subjectId: meetingId,
        pendingCorrelationId,
        transcriptQueryKey: thematicMeetingTranscriptKey,
        requestRecap: (id, correlationId) =>
            thematicMeetingService.generateRecap(id, correlationId),
    });
